import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import { useTranslation } from 'react-i18next'
import type { LayoutPickMenuState, PrintLayoutOption } from './types'

type Props = {
  menu: LayoutPickMenuState | null
  options: PrintLayoutOption[]
  onClose: () => void
  onPick: (opt: PrintLayoutOption, ctx: LayoutPickMenuState) => void
}

export function PrintLayoutPickerMenu({ menu, options, onClose, onPick }: Props) {
  const { t } = useTranslation()
  return (
    <Menu anchorEl={menu?.anchorEl ?? null} open={Boolean(menu)} onClose={onClose}>
      <MenuItem disabled>
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {t('entityList.layout', 'Layout')}
        </Typography>
      </MenuItem>
      {options.map((opt) => (
        <MenuItem
          key={`${opt.source}-${opt.id}`}
          onClick={() => {
            if (!menu) return
            onClose()
            onPick(opt, menu)
          }}
        >
          {opt.name}
          {opt.is_default ? <Chip label="★" size="small" sx={{ ml: 1, height: 20 }} /> : null}
        </MenuItem>
      ))}
    </Menu>
  )
}
